import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const CTA_LINK = 'https://mareaa.online/checkout/v3/start/1972060668/25acb4abfe837a80a6772bcc7e308b2d3875c2d2?from_store=1&country=AR';
export function ForYouSection() {
  const items = ['Te levantás deshinchada pero terminás el día con el abdomen inflamado', 'Comés sano y aun así seguís hinchada', 'Sentís que la ropa ya no te queda igual', 'Te sentís pesada después de comer', 'Ya probaste dietas y nada te funcionó'];
  return <section className="w-full bg-bg-soft py-14 px-4 md:px-8" data-id="element-80">
      <div className="max-w-2xl mx-auto" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-8" data-id="element-82">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif text-text-dark" data-id="element-83">
            Esta guía es para vos si…
          </h2>
        </motion.div>

        <div className="space-y-3 mb-8" data-id="element-84">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.07
        }} className="flex items-start gap-3 bg-white p-5 rounded-xl border border-secondary-light/20 shadow-sm" data-id="element-85">
              <span className="text-accent text-lg flex-shrink-0" data-id="element-86">✓</span>
              <span className="text-primary-mid" data-id="element-87">{item}</span>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-88">
          <motion.a href={CTA_LINK} onClick={trackAddToCart} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center gap-3 bg-accent hover:bg-accent/90 text-white font-bold px-10 py-5 rounded-full shadow-lg shadow-accent/25 transition-all duration-300 text-base md:text-lg" data-id="element-89">
            QUIERO EMPEZAR HOY
            <ArrowRightIcon className="w-5 h-5" data-id="element-90" />
          </motion.a>
        </div>
      </div>
    </section>;
}